import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IContabilidade } from '../interfaces/contabilidade/icontabilidade';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContabilidadeService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http
      .get(`${environment.url}/accounting_firms`).pipe(map((res: any) => res['hydra:member']))  as Observable<
      IContabilidade[]
    >;
      //.pipe(map((res: any) => res['hydra:member'])) 
  }

  save(req: IContabilidade) {
    return this.http.post(
      `${environment.url}/accounting_firms`,
      req
    ) as Observable<IContabilidade>;
  }

  
  edit(req: IContabilidade, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(
      `${environment.url}/accounting_firms/${id}`,
      req,
      { headers: headers }
    ) as Observable<IContabilidade>;
  }

  delete(id: number) {
    return this.http.delete(
      `${environment.url}/accounting_firms/${id}`
    ) as Observable<IContabilidade>;
  }
}
